// extracted by mini-css-extract-plugin
export default {"UserSelect":"UserSelect_UserSelect__5izXO","user-select-wrapper":"UserSelect_user-select-wrapper__gP6qj"};